import Pikaday from 'pikaday';
import { $win, $hero, $wrapper, getElementPosition } from './utils';

const format = 'DD/MM/YYYY';

const initBookingDatepicker = () => {
	const $datepickers = $('.js-bm-container');
	let isKeyboard = false;

	$datepickers.each((index, el) => {
		const $datepicker = $(el);
		const fieldStart = el.querySelector('.js-datepicker-start');
		const fieldStartHidden = el.querySelector('.js-datepicker-start-hidden');
		const fieldEnd = el.querySelector('.js-datepicker-end');
		const fieldEndHidden = el.querySelector('.js-datepicker-end-hidden');
		const containerStart = el.querySelector('.js-datepicker-container-start');
		const containerEnd = el.querySelector('.js-datepicker-container-end');

		let startDate, endDate;

		const todayDate = moment().format('D');
		const tomorrowDate = moment(todayDate, format).add(1, 'days').format('D');

		$(fieldStart).val(todayDate);
		$(fieldStartHidden).val(moment().format('MM/DD/YYYY'));
		$(fieldEnd).val(tomorrowDate);
		$(fieldEndHidden).val(moment(todayDate, format).add(1, 'days').format('MM/DD/YYYY'));

		const options = {
			minDate: new Date(),
			numberOfMonths: 1,
			bound: true,
			format,
			firstDay: 1,
			i18n: {
				previousMonth : 'Previous Month',
				nextMonth     : 'Next Month',
				months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
				weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
				weekdaysShort: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
			}
		}

		const updateStartDate = () => {
			startPicker.setStartRange(startDate);
			endPicker.setStartRange(startDate);
			endDate = moment(startDate).add('1','day')._d;
			endPicker.setMinDate(endDate);
			endPicker.setDate(endDate);
			startPicker.setEndRange(endDate);

			// if ( previewElStart ) {
			// 	previewElStart.textContent = moment(startDate).format('D MMM');
			// 	previewElStart.classList.remove('disabled');
			// 	previewElStart.classList.add('active');
			// 	previewElEnd.classList.add('active');
			// }
		}

		const updateEndDate = () => {
			startPicker.setEndRange(endDate);
			endPicker.setEndRange(endDate);

			// if ( previewElStart ) {
			// 	previewElEnd.textContent = moment(endDate).format(format);
			// 	$(previewElEnd).prev().addClass('active');
			// }
		}

		const startPicker = new Pikaday({
			field: fieldStart,
			container: containerStart,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					startDate = this.getDate();
					updateStartDate();

					setTimeout(function() {
						const nextDate = moment(startDate).add(1, 'days');
						const selectedMonth = nextDate.month();
						const selectedYear = nextDate.year();

						$(fieldEnd).val(nextDate.format(format));
						$(fieldEndHidden).val(nextDate.format('MM/DD/YYYY'));

						// previewElEnd.textContent = nextDate.format(format);
						// $(previewElEnd).prev().addClass('active');
						endPicker.setEndRange(nextDate._d);

						endPicker.gotoMonth(selectedMonth);
						endPicker.gotoYear(selectedYear);

						$(fieldEnd).focus();
					}, 10);
				}
			}
		});

		const endPicker = new Pikaday({
			field: fieldEnd,
			container: containerEnd,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					endDate = this.getDate();
					updateEndDate();
				}
			}
		});

		const _startDate = startPicker.getDate();
		const _endDate = endPicker.getDate();

		if (_startDate) {
			startDate = _startDate;
			updateStartDate();
		}
		if (_endDate) {
			endDate = _endDate;
			updateEndDate();
		}

		// $(fieldStart).add($(fieldEnd)).on('focusin', function(event) {
		// 	$(container).parent().addClass('active');
		// })
		// .on('focusout', function() {
		// 	$(container).parent().removeClass('active');
		// });

		$(fieldEnd).on('focusin', function() {
			if ( !endDate && isKeyboard ) {
				endDate = moment(startDate, format).add(1, 'days')._d;

				endPicker.setDate(endDate);

				updateEndDate();
			}
		});

		$(fieldStart).on('change', function(event) {
			$(fieldStartHidden).val(moment($(fieldStart).val(), 'DD/MM/YYYY').format('MM/DD/YYYY'));
		});

		$(fieldEnd).on('change', function(event) {
			$(fieldEndHidden).val(moment($(fieldEnd).val(), 'DD/MM/YYYY').format('MM/DD/YYYY'));
		});

		$(fieldStart).on('keydown', function(event) {
			const code = event.keyCode;
			const currentDate = startPicker.getDate() ? startPicker.getDate() : new Date();

			if ( code == 37 || code == 38 || code == 39 || code == 40 ) {
				startDate = updateDateByKeyboard(currentDate, code);

				if ( startPicker._o.maxDate && startDate.getTime() > startPicker._o.maxDate.getTime() ) {
					startDate = startPicker._o.maxDate;
				}

				// Prevent startDate from going to a date before the minDate
				if ( startDate.getTime() < startPicker._o.minDate ) {
					startDate = startPicker._o.minDate;
				}

				// Check if the endDate is the day after startDate
				const isEndDateNext = endDate ? endDate.getTime() == moment(startDate, format).add(1, 'days')._d.getTime() : false;

				if (isEndDateNext) {
					// If it is, re-set the startDate to the day before that
					startDate == moment(endDate, format).subtract(1, 'days')._d;

					setTimeout(function() {
						startPicker.setDate(startDate);
					}, 10);
				}

				updateStartDate();
			}
		});

		$(fieldEnd).on('keydown', function(event) {
			const code = event.keyCode;
			const currentDate = endPicker.getDate() ? endPicker.getDate() : endPicker._o.minDate;

			if ( code == 37 || code == 38 || code == 39 || code == 40 ) {
				endDate = updateDateByKeyboard(currentDate, code);

				if ( endPicker._o.minDate && endDate.getTime() < endPicker._o.minDate.getTime() ) {
					endDate = endPicker._o.minDate;
				}

				if ( startDate ) {
					// Prevent startDate from going over endDate
					if ( startDate.getTime() == endDate.getTime() ) {
						endDate = moment(endDate, format).add(1, 'days')._d;

						setTimeout(function() {
							$(fieldEnd).val(endDate);
						}, 10);
					}
				}

				// Check if the startDate is the day before endtDate
				const isStartDatePrev = startDate ? startDate.getTime() == moment(endDate, format).subtract(1, 'days')._d.getTime() : false;

				if (isStartDatePrev) {
					// If it is, re-set the startDate to the day before that
					endDate == moment(startDate, format).add(1, 'days')._d;

					setTimeout(function() {
						endPicker.setDate(endDate);
					}, 10);
				}

				updateEndDate();
			}
		});

		function updateDateByKeyboard(originalDate, code) {
			let date;

			if ( code == 37 || code == 38 || code == 39 || code == 40 ) {
				isKeyboard = true;
			}

			switch(code){
				case 37:
					date = moment(originalDate, format).subtract(1, 'days')._d;
					break;
				case 38:
					date = moment(originalDate, format).subtract(7, 'days')._d;
					break;
				case 39:
					date = moment(originalDate, format).add(1, 'days')._d;
					break;
				case 40:
					date = moment(originalDate, format).add(7, 'days')._d;
					break;
			}

			setTimeout(function() {
				isKeyboard = false;
			}, 20);

			return date;
		}

		$(window).on('load scroll', () => {
			el.setAttribute('placement', getElementPosition(el));
		});
	});
}

const handleChildren = () => {
	const $input = $('.js-bm-children');
	const template = $('#childrenSelectTemplate').html();
	let currentCount = 0;
	const $container = $('#children-selects');

	$input.on('change', function() {
		const value = Number($(this).val());

		if (value > currentCount) {
			const $childSelect = $(template);
			const $select = $childSelect.find('select');

			$select.attr('name', 'childrenAge' + currentCount)
			$select.niceSelect();
			$childSelect.find('.child-number').text(currentCount + 1);

			$container.append($childSelect);
		} else {
			const $lastSelect = $container.find('.qty').last();

			$lastSelect.remove();
		}

		$container.toggleClass('d-none', value == 0);

		currentCount = value;
	});
}

export default function bookingUI() {
	const container = document.getElementById('booking-mask');
	
	initBookingDatepicker();

	$('.booking-mask__field, .select select').on('input change', function() {
		const $this = $(this);
		const val = $this.val();

		$this.closest('.booking-mask__controls').toggleClass('filled', val.length > 0);
	});

	$win.on('scroll', function() {
		const scrollTop = $win.scrollTop();

		if ($hero.length) {
			if (scrollTop === 0) {
				$wrapper.find('.booking-mask__body').removeAttr('style')
			}

			$wrapper.toggleClass('show-bar', scrollTop > 300);
		}
	});
	$win.trigger('scroll');

	handleChildren();

	if ($hero.length === 0) {
		$wrapper.addClass('show-bar');
	}

	$('.js-toggle-form').on('click', function(event) {
		event.preventDefault();

		const duration = 400;

		if (container.classList.contains('active')) {
			$(container.querySelector('.booking-mask__body')).slideUp(duration, () => {
				container.classList.remove('active');
			});
		} else {
			$(container.querySelector('.booking-mask__body')).slideDown(duration);
			container.classList.add('active');
		}
	});

	$('#guests-modal').on('show.bs.modal', function() {
		$('body').addClass('booking-mask__modal__open');
	}).on('hide.bs.modal', function() {
		$('body').removeClass('booking-mask__modal__open');
	});

}
